import { render, staticRenderFns } from "./ApplicantsImportView.vue?vue&type=template&id=06d8b49b"
import script from "./ApplicantsImportView.vue?vue&type=script&lang=js"
export * from "./ApplicantsImportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports